module.exports = __webpack_public_path__ + "img/md-moon.99ab2f96.svg";